function adjustBoxElements() {
    const screenWidth = window.innerWidth;
    const itemsContainer = document.querySelector('.home-3items-section');
    const titles = itemsContainer.querySelectorAll('.container-clean-air .promobox__text_item_1');
    const paras = itemsContainer.querySelectorAll('.container-clean-air .promobox__text_item_2');

    let titleMaxHeight = 0;
    let paraMaxHeight = 0;
    titles.forEach(title => {
        const titleHeight = title.offsetHeight;
        if (titleHeight > titleMaxHeight) {
            titleMaxHeight = titleHeight;
        }
    });

    paras.forEach(para => {
        const paraHeight = para.offsetHeight;
        if (paraHeight > paraMaxHeight) {
            paraMaxHeight = paraHeight;
        }
    });

    titles.forEach(title => {
        title.style.minHeight = `${titleMaxHeight}px`;
    });
    paras.forEach(para => {
        para.style.minHeight = `${paraMaxHeight}px`;
    });
}

window.addEventListener('resize', adjustBoxElements);
window.addEventListener('load', adjustBoxElements);

adjustBoxElements();
